export function truncateString(str: String, maxLength: number) {
    if (str.length <= maxLength) {
        return str;
    } else {
        return str.substring(0, maxLength - 3) + "...";
    }
}